import React from 'react'

import * as S from './styles'

import IProps from './props'

import { formatString, daysOfWeek, daysOfWeekMapper } from './utils'

const RankCard = ({ title, score, position }: IProps) => (
  <S.Container>
    <S.Position>{`${position}°`}</S.Position>
    <S.Content>
      <S.Name>
        {daysOfWeek.includes(title)
          ? daysOfWeekMapper[title as keyof typeof daysOfWeekMapper]
          : formatString(title)}
      </S.Name>
      <S.Score>{`${score} pesquisas`}</S.Score>
    </S.Content>
  </S.Container>
)

export default RankCard
